module.exports = __webpack_public_path__ + "img/imarch.e578d16d.png";